/**
 * Most storage measurements are in gigabytes
 */
export function bytesToGigabytes(bytes: number): number {
	return bytes / 1_000_000_000;
}
